
import { defineComponent } from '@nuxtjs/composition-api';
import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import CheckIcon from '@/assets/svg/check-circle.vue.svg';
import PublicPortfolioConfirmSendRequest from '@/components/partials/public-portfolio/PublicPortfolioConfirmSendRequest.vue';
import PublicPortfolioConnectionActionsMixin from '@/components/partials/public-portfolio/PublicPortfolioConnectionActions/PublicPortfolioConnectionActionsMixin';
import { publicPortfolioPopUps } from '@/components/partials/public-portfolio/constants';

export default defineComponent({
  name: 'PublicPortfolioConnectionActions',
  components: {
    BravadoButtonV3,
    CheckIcon,
    PublicPortfolioConfirmSendRequest,
  },
  mixins: [PublicPortfolioConnectionActionsMixin],
  data() {
    return {
      wasRecentlyDeclined: false,
    };
  },
  computed: {
    currentUserProfile() {
      return this.$auth.user?.slug === this.$route.params.slug;
    },
    showConnectionActions(): boolean {
      return this.$auth.loggedIn && !this.currentUserProfile && !this.isConnected;
    },
  },
  methods: {
    sendRequest() {
      if (this.wasRecentlyDeclined) {
        this.wasRecentlyDeclined = false;
        this.$modal.show(publicPortfolioPopUps.CONFIRM_SEND_REQUEST);
        return;
      }

      this.$analytics.logEvent('public-portfolio__request__button__click');

      return this.sendConnectionRequest();
    },
    acceptRequest() {
      this.$analytics.logEvent('public-portfolio__accept__button__click');

      return this.acceptConnectionRequest();
    },
    declineRequest() {
      this.$analytics.logEvent('public-portfolio__decline__button__click');

      this.wasRecentlyDeclined = true;

      return this.declineConnectionRequest();
    },
  },
});
